import React from 'react';
import { Icon } from '@iconify/react';

function formatRatingValue(rating) {
  const value = Number(rating);
  if (!Number.isFinite(value)) return '0';
  if (value % 1 === 0) return String(value);
  return value.toFixed(1);
}

function StarRatingDisplay({
  rating = 0,
  max = 5,
  showValue = true,
  size = 14,
  className = '',
}) {
  const value = Math.max(0, Math.min(max, Number(rating) || 0));

  return (
    <div className={`tw-inline-flex tw-items-center tw-gap-[4px] star-rating-display   ${className}`.trim()}>
      <span className="tw-inline-flex tw-items-center tw-gap-[1px] star-rating-display__stars">
        {Array.from({ length: max }, (_, index) => {
          const starNumber = index + 1;
          let icon = 'mdi:star-outline';

          if (value >= starNumber) {
            icon = 'mdi:star';
          } else if (value >= starNumber - 0.5) {
            icon = 'mdi:star-half-full';
          }

          return (
            <Icon
              key={starNumber}
              icon={icon}
              width={size}
              height={size}
              className="tw-text-[#ffc107] tw-shrink-[0] star-rating-display__icon"
            />
          );
        })}
      </span>
      {showValue && <span className="rating-value">{formatRatingValue(value)}</span>}
    </div>
  );
}

export default StarRatingDisplay;
